import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import './FrontendTechnologies.css';

const technologies = {
  "Javascript Frameworks": [
    { name: "Angular", logo: "/assets/tech-logos/angular.png" },
    { name: "React", logo: "/assets/tech-logos/react.png" },
    { name: "Next.js", logo: "/assets/tech-logos/nextjs.png" },
    { name: "Vue.js", logo: "/assets/tech-logos/vue.png" },
    // { name: "Meteor", logo: "/assets/tech-logos/meteor.svg" }
  ],
  "Javascript Development Languages": [
    { name: "JavaScript", logo: "/assets/tech-logos/javascript.png" },
    { name: "TypeScript", logo: "/assets/tech-logos/typescript.png" }
  ],
  "CSS Frameworks": [
    { name: "Bootstrap", logo: "/assets/tech-logos/bootstrap.svg" },
    { name: "Material UI", logo: "/assets/tech-logos/material-ui.svg" },
    { name: "Tailwind CSS", logo: "/assets/tech-logos/tailwind.png" }
  ],
  "Asset Builders (Transcompiler)": [
    { name: "Gulp", logo: "/assets/tech-logos/gulp.svg" },
    { name: "Webpack", logo: "/assets/tech-logos/webpack.svg" },
    { name: "PWA", logo: "/assets/tech-logos/pwa.svg" }
  ]
};

const FrontendTechnologies = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <Box className="frontend-technologies-section">
      <Container maxWidth="lg">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            FRONTEND
          </Typography>

          {Object.entries(technologies).map(([category, techs]) => (
            <Box key={category} className="technology-category">
              <Typography variant="h4" className="category-title" gutterBottom>
                {category}
              </Typography>
              <Grid container spacing={3}>
                {techs.map((tech) => (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={tech.name}>
                    <motion.div variants={itemVariants}>
                      <Paper elevation={2} className="technology-card">
                        <img
                          src={tech.logo}
                          alt={tech.name}
                          className="technology-logo"
                        />
                        <Typography variant="subtitle1" className="technology-name">
                          {tech.name}
                        </Typography>
                      </Paper>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </motion.div>
      </Container>
    </Box>
  );
};

export default FrontendTechnologies; 